export default "__VITE_ASSET__1b8c204b__"